import React, { useState } from 'react';
import Popup from './Popup';
import { useQuery } from 'react-apollo';
import pageContentQuery from '../Util/PageContentQuery.gql';
import TextContent from './TextContent';

const ContentPopup = ({ pageId, className = '', title = false }) => {
  const result = useQuery(pageContentQuery, {
    variables: { id: pageId }
  });
  const page = result.data?.page;
  const [popup, showPopup] = useState(false);

  if (!page) return null;

  return (
    <>
      <button onClick={() => showPopup(true)}>
        {title || (page && page.mainHeader)}
      </button>
      {popup && (
        <Popup isOpen={popup} closePopup={() => showPopup(false)}>
          <TextContent content={page.content} />
        </Popup>
      )}
    </>
  );
};

export default ContentPopup;
